import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=21764b7f&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/error.css?vue&type=style&index=0&id=21764b7f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21764b7f",
  null
  
)

export default component.exports